type Props = { className?: string };

/** Bloque animado para placeholder de loading. Usa Tailwind animate-pulse. */
export default function Skeleton({ className = "" }: Props) {
  return <div className={`animate-pulse bg-ink-800 rounded ${className}`} />;
}

/** Skeleton de N filas tipo tabla. */
export function SkeletonRows({ rows = 5, cols = 5 }: { rows?: number; cols?: number }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex gap-3">
          {Array.from({ length: cols }).map((_, c) => (
            <Skeleton
              key={c}
              className={`h-4 ${c === 0 ? "w-32" : c === cols - 1 ? "w-20" : "flex-1"}`}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
